import { Card, Paper, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';
import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { useMobileApp } from '../../../../../../../../hooks/useMobileApp';
import { Booth } from '../../../../../../../../interfaces/interfaces';
import { getBoothVideoViews } from '../../../../../../../../services/services';

export interface BoothVideoViews {
  views: number;
  videoDetails: {
    booth: string;
    video: string;
    type: string;
    videoApiId: string;
    videoApiHls: string;
    muxId: string;
    muxPlaybackIds: any[];
    thumbnail: string;
    autoplay: boolean;
    datetime_deleted?: Date;
    _id: string;
  };
}
export const BoothVideoViews = ({ booth }: { booth: Booth }) => {
  const [boothVideoViews, setBoothVideoViews] = useState<BoothVideoViews[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { isAppView } = useMobileApp();

  const { t } = useTranslation();
  useEffect(() => {
    fetchData();
  }, [booth]);

  async function fetchData() {
    try {
      const boothVideoViewsCount = await getBoothVideoViews(booth._id);
      setBoothVideoViews(boothVideoViewsCount);
      setIsLoading(false);
    } catch (err) {
      console.error(err);
    }
  }
  return (
    <>
      {boothVideoViews.length !== 0 && (
        <div className=" mt-8 w-auto">
          {isLoading ? (
            <Card className="w-full" elevation={3}>
              <div className="text-center m-4">
                <Skeleton animation="wave" height={30} width="100%" style={{ marginBottom: 6 }} />
                <Skeleton animation="wave" height={30} width="100%" style={{ marginBottom: 6 }} />
                <Skeleton animation="wave" height={30} width="100%" style={{ marginBottom: 6 }} />
              </div>
            </Card>
          ) : (
            <TableContainer elevation={3} component={Paper}>
              <div className="ml-2 mt-4 mb-2 pl-4">
                <Typography className="font-size: 1rem;line-height: 1.5rem; capitalize" color="textSecondary" gutterBottom>
                  {t('stats:video-views-track')}
                </Typography>
              </div>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">{t('stats:video-display')}</TableCell>
                    <TableCell align="right">{t('stats:video-views-number')}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {boothVideoViews.map((data, i) => (
                    <TableRow key={data.videoDetails._id}>
                      <TableCell align="left">
                        <ReactPlayer
                          playsinline={isAppView()}
                          url={data.videoDetails?.video}
                          width="30%"
                          height="30%"
                          className="overflow-hidden h-full"
                          controls
                        />
                      </TableCell>
                      <TableCell align="right">{data.views}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </div>
      )}
    </>
  );
};
